import type { EntityState } from '../../lib/api.js';
import { friendlyName, formatRelativeTime } from '../../lib/utils.js';

interface Props {
  entityId: string;
  entity: EntityState;
}

export function SensorCard({ entityId, entity }: Props) {
  const unit =
    typeof entity.attributes['unit_of_measurement'] === 'string'
      ? (entity.attributes['unit_of_measurement'] as string)
      : '';
  return (
    <div
      className="p-4 rounded-xl border"
      style={{ backgroundColor: 'var(--ac-surface)', borderColor: 'var(--ac-border)' }}
    >
      <div className="text-sm text-[var(--ac-text-muted)]">
        {friendlyName(entityId, entity.attributes)}
      </div>
      <div className="text-2xl font-semibold text-[var(--ac-text)] mt-1">
        {entity.state}
        {unit ? <span className="ml-1 text-base text-[var(--ac-text-muted)]">{unit}</span> : null}
      </div>
      {entity.lastChanged ? (
        <div className="text-xs text-[var(--ac-text-muted)] mt-2">
          {formatRelativeTime(entity.lastChanged)}
        </div>
      ) : null}
    </div>
  );
}
